import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/endpoint';

export const BASE_USER_PROFILE_URL = `${SERVER_API}/user-profiles`;

export const USER_PROFILE_ENDPOINTS = {
  LIST: {
    method: 'GET',
    url: `${BASE_USER_PROFILE_URL}`,
  } as IEndpointData,
  CREATE: {
    method: 'POST',
    url: `${BASE_USER_PROFILE_URL}`,
  } as IEndpointData,
  GET(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_USER_PROFILE_URL}/${id.toString()}`,
    };
  },
  UPDATE(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${BASE_USER_PROFILE_URL}/${id.toString()}`,
    };
  },
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${BASE_USER_PROFILE_URL}/${id.toString()}`,
    };
  },
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_USER_PROFILE_URL}/${id.toString()}/history`,
    };
  },
  ACTIVATE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_USER_PROFILE_URL}/${id.toString()}/activate`,
    };
  },
  DEACTIVATE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${BASE_USER_PROFILE_URL}/${id.toString()}/deactivate`,
    };
  },
  CALENDAR(profileId: number): IEndpointData {
    return {
      method: 'GET',
      url: `${BASE_USER_PROFILE_URL}/${profileId.toString()}/calendar`,
    };
  },
};
